import { Component, OnInit } from '@angular/core';
import { Game, config, GameService, GameQuery, GameDataSource } from '@fgb/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-next-game',
  templateUrl: './next-game.component.html',
  styleUrls: ['./next-game.component.scss'],
})
export class EventsComponent implements OnInit {
  nextGame$: Observable<Game | null>;
  awayTeamName: string;

  constructor(private gameService: GameService, private gameQuery: GameQuery) {}

  ngOnInit() {
    this.gameService.fetchGames('', GameDataSource.Club).toPromise();
    this.nextGame$ = this.gameQuery.selectNextGame(GameDataSource.Club).pipe(
      tap((game) => {
        if (game) {
          if (game.TeamNames.AwayTeamName == null || game.TeamNames.AwayTeamName == '') {
            let teams = game.Teams.toLowerCase().split(' at ');
            this.awayTeamName = teams[0];
          } else {
            this.awayTeamName = game.TeamNames.AwayTeamName;
          }
        }
      })
    );
  }

  getTeamLogoUrl(teamId: number) {
    return `${config.contentUrl}/image/teams/${teamId}__1_1_1033.png`;
  }
}
